import { createFileRoute } from '@tanstack/react-router'
import { PublicLabelPage } from '../components/labels/PublicLabelPage'

// Public QR label scan page (spec 2026-08-17-03).
//
// It lives outside routes/$org, so it inherits no auth guard — which is the
// point: the reader is a resident or a passer-by who photographed a sticker in
// a hall and has no account. The label code in the path is the whole request,
// and the server answers with a strict allow-list.
export const Route = createFileRoute('/q/$code')({
    component: PublicLabelRoute,
})

function PublicLabelRoute() {
    const { code } = Route.useParams()

    return <PublicLabelPage code={code} />
}
